<mat-card>
    <mat-card-header class="nopadding">
        <span class="card-header-value">MY CONSENT</span>
    </mat-card-header>

    <mat-card-content>
        <p>This page gives you a clear view of all the consents you've provided as part of using our service. We believe
            it is
            important that you are always in control of your data and how it is used. You can review and manage your
            consents here,
            and any analysis of your sample or data will only take place if you have explicitly agreed to it.
        </p>

        <h4>Sample and Sequencing</h4>
        <ng-container *ngIf="!isLoadingKitStatus && !hasKitRegistered">
            <mat-card-content class="mat-typography">
                <p>You have not yet registered a kit.Once you have completed this process your consent option will be saved here.</p>
            </mat-card-content>
            <p>
                <button id="order_test_button" mat-flat-button color="primary" class="kit-button" (click)="orderTest()">Register a Kit</button>
            </p>
        </ng-container>

        <ng-container *ngIf="!isLoadingKitStatus && hasKitRegistered">
        <mat-dialog-content>
            <form [formGroup]="consentForm" validate autocomplete="off">
                <div *ngFor="let c of consents">
                    <div *ngIf="c.mandatory" class="checkbox-flex">
                        <mat-checkbox [formControlName]="'consent_' + c.id" [id]="'consent_' + c.id"
                                  [required]="c.mandatory" [disabled]="hasKitRegistered && c.mandatory"(keydown)="onFocusEvent($event)">
                        <span class="consent-description">
                            {{ c.description }}
                            <span *ngIf="c.mandatory" class="mandatory-asterisk">*</span>
                        </span>
                          </mat-checkbox>
                        </div>
                    </div>

                    <div class="contact-storegene">If you would like to change Consent please message StoreGene team at
                        <a href="mailto:contact@storegene.com">contact@storegene.com</a></div>
                    <h4>Optional Consent</h4>
                    <div *ngFor="let c of consents">
                        <div *ngIf="!c.mandatory" class="checkbox-flex">
                            <mat-checkbox [formControlName]="'consent_' + c.id" [id]="'consent_' + c.id"
                                (keydown)="onFocusEvent($event)"
                                (change)="onOptionalConsentChange()">

                                <span class="consent-description">
                                    {{ c.description }}
                                </span>
                            </mat-checkbox>
                        </div>
                    </div>
                    <button *ngIf="hasOptionalConsentChanged" mat-button type="button"
                        class="save-btn-container" mat-flat-button color="primary" (click)="onSave()">Save</button>
                </form>
            </mat-dialog-content>
        </ng-container>
        <!-- <h4>Analysis Request</h4>

        <mat-dialog-content class="mat-typography">
            <form [formGroup]="consentForm" validate autocomplete="off">
                <div *ngFor="let a of analysisRequests">
                    <div class="checkbox-flex">
                        <mat-checkbox 
                            [id]="'analysis_' + a.id"
                            [attr.aria-label]="a.id"
                            [required]="a.mandatory">
                            {{ a.description }}
                            <span *ngIf="a.mandatory" class="mandatory-asterisk">*</span>
                        </mat-checkbox>
                    </div>
                </div>
            </form>
        </mat-dialog-content> -->
    </mat-card-content>
</mat-card>